// this is for the bad primereact calendar, b always crying for duplicated key in dom...
//import ProxyPolyfill from 'proxy-polyfill/src/proxy';

//const Proxy = new ProxyPolyfill();

const error = window.console.error;
window.console.error = function() {
    const args = Array.prototype.slice.call(arguments);
    if (
        !((args[2] || "").indexOf("created by Calendar") !== -1 && (args[1] || "") === "Sz" && (args[0] || "").indexOf("same key,") !== -1)
        &&
        (
            typeof args[0] === "string"
            &&
            (args[0] || "").indexOf("Invalid prop `label` of type `object` supplied to `SplitButton`, expected `string`") === -1
            &&
            ((args[0] || "").indexOf("Invalid prop `label` of type `object` supplied to `Button`, expected `string`") === -1 && (args[0] || "").indexOf("SplitButton") === -1)
            &&
            ((args[0] || "").indexOf("Invalid prop `label` of type `object` supplied to `MultiSelectItem`, expected `string`") === -1 && (args[0] || "").indexOf("MultiSelect") === -1)
        )
    ) {
        error.apply(window.console, args);
    }
}
/*const console = new Proxy(_console, {
    get: function(obj, prop) {
        if (typeof obj[prop] === 'function' && prop === 'error') {
            return function () {
                const args = Array.prototype.slice.call(arguments);
                // this is for the bad primereact calendar, b always crying for duplicated key in dom...
                if (!(args[0].indexOf("created by Calendar") !== -1 && args[0].indexOf("`Sz`.") !== -1)) {
                    //_console.error.apply(_console, args);
                }
            }
        }
        return (typeof obj[prop] === 'function') ? obj[prop].bind(obj) : obj[prop];
    }
});*/
//window.console = console;